const ITEMS = [
  "CREATIVE DESIGN",
  "LOGOS",
  "PORTRAITS",
  "COMIC BOOKS",
  "CHILDREN'S BOOKS",
  "BUSINESS CARDS",
  "ILLUSTRATIONS",
];

export const Marquee = () => {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee"
      className="overflow-hidden border-y border-[#E3E5E9] py-5 bg-white"
    >
      <div className="marquee">
        {loop.map((item, i) => (
          <span
            key={`${item}-${i}`}
            className="text-xs sm:text-sm font-semibold uppercase tracking-[0.28em] text-[#6B7280] px-7 flex items-center gap-7 whitespace-nowrap"
          >
            {item}
            <span className="text-[#3E6FA8] text-base">•</span>
          </span>
        ))}
      </div>
    </div>
  );
};
